<template>
	<div class="user-watches-devices">
		<navigation :user_uid="user_uid" @viewMode="setViewMode"/>
		<spinner v-if="loading"/>
		<devices-grid v-if="!loading && isGridMode" :user_uid="user_uid" :groups="groups"/>
		<devices-list v-if="!loading && isListMode" :user_uid="user_uid" :groups="groups" @deleteGroup="onDeleteGroup" @deleteDevice="onDeleteDevice"/>
	</div>
</template>

<script>
import Navigation from './UserWatchesNavigation'
import DevicesGrid from './UserWatchesDevicesGrid'
import DevicesList from './UserWatchesDevicesList'
import ApiCollection from '@/classes/api/ApiCollection'
import GroupCollection from '@/classes/GroupCollection'
import DeviceCollection from '@/classes/DeviceCollection'
export default {
	components: {
		Navigation,
		DevicesGrid,
		DevicesList
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			groups: new ApiCollection(),
			devices: new ApiCollection(),
			viewMode: 'list'
		}
	},
	computed: {
		loading () {
			return this.groups.loading || this.devices.loading
		},
		isGridMode () {
			return this.viewMode === 'grid'
		},
		isListMode () {
			return this.viewMode === 'list'
		}
	},
	methods: {
		getGroups () {
			this.groups.loading = true
			this.groups.data = []
			return this.$api.groups.devices.getAll(this, this.user_uid)
				.then(response => {
					this.$log.info('groups', 'groups.devices.getAll OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error('groups', 'groups.devices.getAll ERROR', error)()
					this.groups.error = error
				}).finally(() => {
					this.groups.loading = false
				})
		},
		getDevices () {
			this.devices.loading = true
			this.devices.data = []
			return this.$api.devices.getAll(this, this.user_uid)
				.then(response => {
					this.$log.info('devices', 'devices.getAll OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error('devices', 'devices.getAll ERROR', error)()
					this.devices.error = error
				}).finally(() => {
					this.devices.loading = false
				})
		},
		getData () {
			Promise.all([this.getGroups(), this.getDevices()])
				.then(([groupsData, devicesData]) => {
					this.$log.info('groups + devices', 'getData() OK', groupsData, devicesData)()
					this.devices.data = new DeviceCollection(devicesData)
					this.groups.data = new GroupCollection(groupsData, this.devices.data)
				}).catch(error => {
					this.$log.error('groups + devices', 'getData() ERROR', error)()
				})
		},
		setViewMode (mode) {
			switch (mode) {
				case 'grid':
					this.viewMode = 'grid'
					break
				case 'list':
					this.viewMode = 'list'
					break
				default:
					this.viewMode = 'list'
			}
		},
		onDeleteGroup (group_id) {
			if (confirm(this.$t('buttons.general.delete') + '?')) {
				this.$api.groups.devices.delete(this, this.user_uid, group_id)
					.then(response => {
						this.$log.info('groups', 'groups.devices.delete OK', response)()
					}).catch(error => {
						this.$log.error('groups', 'groups.devices.delete ERROR', error)()
					}).finally(() => {
						this.getData()
					})
			}
		},
		onDeleteDevice (device_id) {
			if (confirm(this.$t('buttons.general.delete') + '?')) {
				this.$api.devices.delete(this, this.user_uid, device_id)
					.then(response => {
						this.$log.info('devices', 'groups.devices.delete OK', response)()
					}).catch(error => {
						this.$log.error('devices', 'groups.devices.delete ERROR', error)()
					}).finally(() => {
						this.getData()
					})
			}
		}
	},
	beforeCreate () {
		this.$title('Devices')
	},
	created () {
		this.$parent.$on('reload', this.getData)
	},
	mounted () {
		this.getData()
	},
	beforeDestroy () {
		this.$parent.$off('reload', this.getData)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesDevices.vue